import {
  // -- GET (list)
  GET_SCENARIO_PARAMETERS_SUCCESS,
  GET_SCENARIO_PARAMETERS_FAILURE,
  // -- CREATE
  CREATE_SCENARIO_PARAMETER_SUCCESS,
  CREATE_SCENARIO_PARAMETER_FAILURE,
  // -- UPDATE
  UPDATE_SCENARIO_PARAMETER_SUCCESS,
  UPDATE_SCENARIO_PARAMETER_FAILURE,
  // -- DELETE
  DELETE_SCENARIO_PARAMETER_SUCCESS,
  DELETE_SCENARIO_PARAMETER_FAILURE,
  // -- SEARCH
  SEARCH_SCENARIO_PARAMETERS
} from '../../../actions'
import { Logger, LoggerTypes } from '../../../utils'

let cacheItems = null

export const scenarioParameters = (state = {}, action) => {
  switch (action.type) {
    // -- GET SCENARIO PARAMETERS (list)
    case GET_SCENARIO_PARAMETERS_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarioParameters.GET_SCENARIO_PARAMETERS_FAILURE()', {
        state,
        action
      })
      return { ...state, error: action.data }
    }
    case GET_SCENARIO_PARAMETERS_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarioParameters.GET_SCENARIO_PARAMETERS_SUCCESS()', {
        state,
        action
      })
      return {
        ...state,
        items: action.data
      }
    }

    // -- CREATE SCENARIO PARAMETER
    case CREATE_SCENARIO_PARAMETER_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarioParameters.CREATE_SCENARIO_PARAMETER_FAILURE()', {
        state,
        action
      })
      return { ...state, error: action.data }
    }
    case CREATE_SCENARIO_PARAMETER_SUCCESS: {
      let newItems = [...state.items]
      newItems.push(action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarioParameters.CREATE_SCENARIO_PARAMETER_SUCCESS()', {
        state,
        action,
        newItems
      })
      return {
        ...state,
        items: newItems
      }
    }

    // -- UPDATE SCENARIO PARAMETER
    case UPDATE_SCENARIO_PARAMETER_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarioParameters.UPDATE_SCENARIO_PARAMETER_FAILURE()', {
        state,
        action
      })
      return { ...state, error: action.data }
    }
    case UPDATE_SCENARIO_PARAMETER_SUCCESS: {
      const items = state.items.map((obj) => [action.data].find((o) => o.id === obj.id) || obj)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarioParameters.UPDATE_SCENARIO_PARAMETER_SUCCESS()', {
        state,
        action,
        items
      })

      return {
        ...state,
        items
      }
    }

    // -- DELETE SCENARIO PARAMETER
    case DELETE_SCENARIO_PARAMETER_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarioParameters.DELETE_SCENARIO_PARAMETER_FAILURE()', {
        state,
        action
      })
      return { ...state, error: action.data }
    }
    case DELETE_SCENARIO_PARAMETER_SUCCESS: {
      const items = state.items.filter((obj) => obj.id !== action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarioParameters.DELETE_SCENARIO_PARAMETER_SUCCESS()', {
        state,
        action,
        items
      })

      return {
        ...state,
        items
      }
    }

    // -- SEARCH SCENARIO
    case SEARCH_SCENARIO_PARAMETERS: {
      const txt = action.data || ''
      if (txt.length <= 1 && cacheItems === null && state.items) {
        cacheItems = [...state.items]
      }

      const escapeRegExp = (value) => value && value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
      const searchRegex = new RegExp(escapeRegExp(txt), 'i')
      const searchItems = (cacheItems || []).filter((row) =>
        Object.keys(row).some((field) => searchRegex.test(((row && row[field]) || '').toString()))
      )
      return {
        ...state,
        items: searchItems
      }
    }

    default:
      return state
  }
}
